import { render } from "./modal2.vue?vue&type=template&id=1fdb046e"
import script from "./modal2.vue?vue&type=script&lang=ts"
export * from "./modal2.vue?vue&type=script&lang=ts"
script.render = render

export default script